import Vue from "vue"
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
const _ = require('lodash')

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default { 
  props: {
    width: {
      type: String,
      default: 'w-50 m-auto'
    },
    show: {
      type: Boolean,
      default: false
    },
    canaddnew: {
      type: Boolean,
      default: true
    },
    customerId: {
      type: [Number, String],
      default: null
    },
    onlyDeposit: {
      type: Boolean,
      default: false
    },
    excludeUuid: {
      type: String,
      default: null
    }
  },
  components: {
    Paginate
  },
  data() {
    return {
      busy: false,
      textInput: '',
      apiStatus: 'ไม่พบข้อมูล',
      perPage: 6,
      sortBy: 'name',
      totalItem: 0,
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      fields: [
        { 
          key: 'document_no', 
          label: 'เลขที่บิล', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2 py-1.5',
          sortable: true 
        },
        { 
          key: 'customer_detail', 
          label: 'ชื่อลูกค้า',
          thClass: 'font-weight-bold text-xs-1/2', 
          tdClass: 'text-gray-400 td-top text-xs-1/2 py-1.5',
          sortable: true 
        },
        { 
          key: 'grand_total', 
          label: 'ยอดขายสุทธิ', 
          sortable: true, 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-black td-top text-left text-xs-1/2 py-1.5'  
        },
        { 
          key: 'action', 
          label: '#', 
          sortable: true, 
          thClass: 'font-weight-bold text-right text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-right text-xs-1/2 py-1.5'  
        }
      ],
      items: [],
     }
  },
  watch: {
    show: function (newValue, oldValue) {
      if (newValue) {
        this.items = []
        this.onSearchHandler(this.currentPage) 
      }
    }
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    onSelected (item) {
      if (item.is_selected_for_deposit) return
      this.$emit('onDocumentCloseHandler', {
        status: true,
        data: item
      })
    },
    rowClass (item) {
      if (item && item.is_selected_for_deposit) return 'text-gray-400 bg-light locked-row'
      return ''
    },
    onClose () {
      this.$emit('onDocumentCloseHandler', {
        status: false
      })
    },
    async onSearchHandler (currentPage) {
      try {
        this.busy = true
        // this.items = []
        const page = currentPage ? currentPage : 1
        this.apiStatus = 'กำลังค้นหาข้อมูล..'
  
        const customerFilter = this.customerId ? `&customer_id=${this.customerId}` : ''
        const excludeFilter = this.excludeUuid ? `&exclude_uuid=${this.excludeUuid}` : ''
        let url
        if (this.onlyDeposit) {
          url = `${Vue.prototype.$host}/api/v1/document/tax-invoice-full?page=${page}&perPage=8&keyword=${encodeURIComponent(this.textInput)}&only_deposit=1${customerFilter}${excludeFilter}`
        } else {
          url = `${Vue.prototype.$host}/api/v1/document/tax-invoice-full?page=${page}&perPage=8&keyword=${encodeURIComponent(this.textInput)}&deposit=true&include_locked=true${customerFilter}${excludeFilter}`
        }
        try {
          const result = await this.$axios.get(
            url
          )
          if (result) {
            this.currentData = result.data
            this.items = result.data.data
            this.totalItem = result.data.total
            this.busy = false

            if(this.items.length === 0) {
                this.apiStatus = 'ไม่พบข้อมูล'
            }
          }
        } catch (error) {
          this.busy = false
          this.apiStatus = 'ไม่พบข้อมูล'
          this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
        }

      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    }
  }
}
